import { Injectable } from '@angular/core';
import { PriceType } from '@core/enums';

@Injectable({
  providedIn: 'root',
})
export class PriceService {
  private showFullPrice: any;

  constructor() {}

  public getPriceWithoutDiscount(rate, priceBy, showAmountTotal) {
    if (this.showFullPrice && rate.price.service_fee) {
      return priceBy === 'TOTAL'
        ? rate.price.price_without_discount + rate.price.service_fee
        : rate.price.price_without_discount + rate.price.service_fee;
      // TODO:  - Cristian.cerroni / 23-10-2020: verify if we need calculate it using  totalNights / totalRooms
    } else {
      if (priceBy === 'TOTAL') {
        if (rate.payment_method.code === 'PREPAID') {
          return showAmountTotal || typeof showAmountTotal === 'undefined'
            ? rate.price.price_without_discount
            : rate.price.show_amount_without_discount;
        } else {
          return rate.price.price_without_discount;
        }
      } else {
        if (rate.payment_method.code === 'PREPAID') {
          return showAmountTotal
            ? rate.price.price_per_night_per_room_without_discount
            : rate.price.show_amount_per_night_per_room_without_discount;
        } else {
          return rate.price.price_per_night_per_room_without_discount;
        }
      }
    }
  }

  public getMapPrice(hotelDetail, priceBy) {
    if (this.showFullPrice && hotelDetail.hasOwnProperty('service_fee')) {
      return Math.ceil(
        priceBy === PriceType.TOTAL_PRICE
          ? hotelDetail.total + hotelDetail.service_fee
          : hotelDetail.total + hotelDetail.service_fee,
      );
      // TODO:  - Cristian.cerroni / 23-10-2020: verify if we need calculate it using  totalNights / totalRooms
    } else {
      return Math.ceil(
        priceBy === PriceType.PRICE_BY_NIGHT
          ? hotelDetail.price_without_discount
          : hotelDetail.total,
      );
    }
  }

  public getMapPriceWithoutDiscount(price, priceBy) {
    if (this.showFullPrice && price.service_fee) {
      return priceBy === 'TOTAL'
        ? price.total_without_discount + price.service_fee
        : price.total_without_discount + price.service_fee;
      // TODO:  - Cristian.cerroni / 23-10-2020: verify if we need calculate it using  totalNights / totalRooms
    } else {
      return Math.ceil(
        priceBy === 'TOTAL' ? price.total_without_discount : price.price_without_discount,
      );
    }
  }
}
